import { playVoice, stopVoice, collectUi } from "./baraa";
import { api } from "./api";

export const TOUR_KEY = "wz_baraa_tour_done";

export const DASHBOARD_TOUR = [
  { id: "nav-search-box", title: "البحث السريع", text: "اكتب هنا اسم أي قسم أو شاشة، مثل الرواتب أو المركبات، وانتقل إليها مباشرة." },
  { id: "view-select-mobile", title: "الأقسام", text: "من هنا تتنقّل بين أقسام النظام: الموظفون، المركبات، الرواتب، الوقود وغيرها." },
  { id: "add-employee-button", title: "إضافة موظف", text: "اضغط هنا لتسجيل موظف أو مندوب جديد. ارفع وثائقه وسيقرأ النظام بياناتها تلقائياً." },
  { id: "operating-cards-button", title: "كروت التشغيل", text: "هنا تضبط كروت التشغيل: ترفعها دفعة واحدة، وترى عدد المناديب على كل كرت، وتنقلهم بين الكروت." },
  { id: "tools-menu-trigger", title: "الأدوات", text: "قائمة الأدوات فيها الاستيراد من Excel، والتقارير، والتصدير الكامل للبيانات." },
  { id: "notification-bell", title: "الإشعارات", text: "الجرس يجمع كل التنبيهات: الوثائق المنتهية، كروت التشغيل، التعبئات المشبوهة وطلبات الموظفين." },
  { id: "check-expiry-now-button", title: "فحص الوثائق", text: "هذا الزر يفحص كل الوثائق الآن ويرسل التنبيهات للوثائق القريبة من الانتهاء." },
  { id: "status-filter-tabs", title: "تصفية الموظفين", text: "صفِّ الموظفين حسب حالة وثائقهم: سارية، قريبة الانتهاء، أو منتهية." },
  { id: "search-input", title: "البحث في الموظفين", text: "ابحث عن أي موظف بالاسم أو رقم الهوية أو رقم الجوال." },
  { id: "user-menu-trigger", title: "حسابك", text: "من قائمة حسابك تغيّر كلمة المرور، وإعدادات الشركة، وتسجيل الخروج." },
  { id: "support-widget-button", title: "الدعم الفني", text: "إذا واجهتك مشكلة، راسل الدعم الفني من هنا وسيرد عليك الفريق." },
  { id: "baraa-launcher", title: "أنا براء", text: "وأنا دائماً هنا! اضغطني واسألني عن أي خطوة وسأشرحها وأشير لك على الزر." },
];

export const DEMO_TOUR_KEY = "wz_demo_tour_done";
export const DEMO_TOUR = [
  { view: "overview", title: "أهلاً بك في WorkZone 👋", text: "هذه نسخة تجريبية لشركة توصيل حقيقية ببيانات وهمية. سنمرّ سريعاً على أهم الأقسام — وكل شيء هنا قابل للتجربة والتعديل." },
  { view: "overview", title: "النظرة العامة", text: "لوحة واحدة تلخّص الشركة: عدد الموظفين، الوثائق المنتهية والقريبة من الانتهاء، وأهم التنبيهات اليومية." },
  { view: "employees", title: "الموظفون والوثائق", text: "ملف كامل لكل موظف: الإقامة والرخصة والعقود مع تنبيهات تلقائية قبل انتهاء أي وثيقة، وقراءة الوثائق بالذكاء الاصطناعي." },
  { view: "vehicles", title: "المركبات والعُهد", text: "أسطولك كاملاً: المركبات وكروت التشغيل والفحص الدوري، وتسليم العُهد للمناديب باستلام موقّع." },
  { view: "salaries", title: "الرواتب", text: "احسب الرواتب تلقائياً حسب التارقت أو المسافة، مع الخصومات والبدلات والسلف، وصدّرها بضغطة." },
  { view: "riders", title: "تحليلات المناديب وكيتا", text: "ارفع ملفات التطبيقات (كيتا، هنجرستيشن…) لترى طلبات كل مندوب ومشرف، والأهداف بالألوان، وترتيب الأفضل والأضعف." },
  { view: "injuries", title: "إصابات العمل", text: "ملف لكل إصابة يجمع صور الحادث وتقرير نجم والمستشفى، ويسحب وثائق المندوب تلقائياً، ويصدّرها ملفاً واحداً." },
  { view: "decisions", title: "القرارات الإدارية", text: "أصدر القرارات والإنذارات على ترويسة الشركة بقوالب جاهزة، وأرسلها للموظف ليوقّعها ببصمته من جواله." },
  { view: "rentals", title: "التأجير", text: "أجّر مركباتك يومياً أو أسبوعياً أو شهرياً، مع تقويم الحجوزات وعقود وفواتير، وتذكير تلقائي بموعد الإرجاع." },
  { id: "open-finance-button", view: "overview", title: "المحاسبي", text: "ومن هنا تفتح WorkZone المحاسبي: القيود والفواتير والتقارير المالية مربوطة ببيانات شركتك. استمتع بالتجربة!" },
];

const visibleEl = (id) => [...document.querySelectorAll(`[data-testid="${CSS.escape(id)}"]`)]
  .find((e) => { const r = e.getBoundingClientRect(); return r.width > 0 && r.height > 0; });

const btn = (label, act, primary) => `<button data-act="${act}" data-testid="baraa-tour-${act}" style="border:0;cursor:pointer;border-radius:999px;padding:6px 14px;font:inherit;font-size:12px;font-weight:700;${primary ? "background:#0ea5e9;color:#fff" : "background:#f1f5f9;color:#475569"}">${label}</button>`;

// Step-by-step spotlight tour; skips steps whose button is not on screen.
export const startTour = ({ steps = DASHBOARD_TOUR, voice = false, onEnd, doneKey = TOUR_KEY, voiceToggle = false } = {}) => {
  const list = steps.filter((s) => !s.id || s.view || visibleEl(s.id));
  if (!list.length) { onEnd?.(); return; }
  document.getElementById("baraa-tour")?.remove();
  const root = document.createElement("div");
  root.id = "baraa-tour";
  root.setAttribute("data-testid", "baraa-tour");
  root.innerHTML = `<style>@keyframes bt-pulse{0%,100%{box-shadow:0 0 0 4px rgba(14,165,233,.6),0 0 0 9999px rgba(15,23,42,.45)}50%{box-shadow:0 0 0 10px rgba(14,165,233,.25),0 0 0 9999px rgba(15,23,42,.45)}}
@keyframes bt-in{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}</style>
<div class="bt-ring" style="position:fixed;border-radius:12px;pointer-events:none;z-index:80;animation:bt-pulse 1.3s ease-in-out infinite;transition:all .3s cubic-bezier(.4,0,.2,1)"></div>
<div class="bt-card" dir="rtl" data-testid="baraa-tour-card" style="position:fixed;z-index:81;width:300px;max-width:calc(100vw - 24px);background:#fff;border-radius:16px;padding:14px;box-shadow:0 18px 40px rgba(15,23,42,.25);transition:left .3s,top .3s"></div>`;
  root.style.fontFamily = getComputedStyle(document.querySelector("#root button") || document.body).fontFamily;
  document.body.appendChild(root);
  const ring = root.querySelector(".bt-ring"), card = root.querySelector(".bt-card");
  let i = 0, el = null;
  const place = () => {
    if (!el) {
      ring.style.display = "none";
      const cw = Math.min(340, window.innerWidth - 24);
      Object.assign(card.style, { width: `${cw}px`, left: `${(window.innerWidth - cw) / 2}px`, top: `${Math.max(12, window.innerHeight / 2 - (card.offsetHeight || 160) / 2)}px`,
        boxShadow: "0 18px 40px rgba(15,23,42,.25), 0 0 0 9999px rgba(15,23,42,.45)" });
      return;
    }
    ring.style.display = "";
    card.style.width = "300px";
    card.style.boxShadow = "0 18px 40px rgba(15,23,42,.25)";
    const r = el.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
    Object.assign(ring.style, { left: `${r.left - 6}px`, top: `${r.top - 6}px`, width: `${r.width + 12}px`, height: `${r.height + 12}px` });
    const cw = Math.min(300, vw - 24), ch = card.offsetHeight || 150;
    const below = r.bottom + 14 + ch < vh;
    const top = below ? r.bottom + 14 : Math.max(12, r.top - ch - 14);
    const left = Math.min(vw - cw - 12, Math.max(12, r.left + r.width / 2 - cw / 2));
    Object.assign(card.style, { left: `${left}px`, top: `${top}px` });
  };
  let curView = null;
  const show = () => {
    const s = list[i];
    if (s.view && s.view !== curView) {
      curView = s.view;
      window.dispatchEvent(new CustomEvent("baraa:open", { detail: { view: s.view } }));
      el = null;
      card.innerHTML = "";
      setTimeout(show, 700);
      return;
    }
    el = s.id ? visibleEl(s.id) : null;
    if (s.id && !el) { if (i < list.length - 1) { i += 1; show(); } else end(); return; }
    el?.scrollIntoView({ behavior: "smooth", block: "center" });
    card.innerHTML = `<div style="animation:bt-in .3s ease-out">
<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px"><b style="font-size:14px;color:#0f172a">${s.title}</b><span style="font-size:11px;color:#94a3b8" data-testid="baraa-tour-step">${i + 1} / ${list.length}</span></div>
<p style="margin:0 0 12px;font-size:12.5px;line-height:1.7;color:#475569">${s.text}</p>
<div style="height:4px;border-radius:9px;background:#f1f5f9;margin-bottom:12px;overflow:hidden"><div style="height:100%;width:${((i + 1) / list.length) * 100}%;background:#0ea5e9;transition:width .3s"></div></div>
<div style="display:flex;gap:6px;justify-content:space-between"><span style="display:flex;gap:6px">${btn("إنهاء", "skip")}${voiceToggle ? btn(voice ? "🔇" : "🔊", "voice") : ""}</span><span style="display:flex;gap:6px">${i ? btn("السابق", "prev") : ""}${btn(i === list.length - 1 ? "تم" : "التالي", "next", true)}</span></div></div>`;
    setTimeout(place, 350);
    place();
    if (voice) playVoice(`${s.title}. ${s.text}`);
  };
  const iv = setInterval(place, 150);
  const end = () => { clearInterval(iv); stopVoice(); root.remove(); window.removeEventListener("keydown", onKey); localStorage.setItem(doneKey, "1"); onEnd?.(); };
  const go = (d) => { const n = i + d; if (n >= list.length) end(); else if (n >= 0) { i = n; show(); } };
  const onKey = (e) => { if (e.key === "Escape") end(); else if (e.key === "ArrowLeft") go(1); else if (e.key === "ArrowRight") go(-1); };
  card.addEventListener("click", (e) => {
    const act = e.target.closest("[data-act]")?.dataset.act;
    if (act === "next") go(1); else if (act === "prev") go(-1); else if (act === "skip") end();
    else if (act === "voice") { voice = !voice; if (voice) { show(); } else { stopVoice(); show(); } }
  });
  window.addEventListener("keydown", onKey);
  show();
};

// Section-specific tour generated by Baraa from the buttons on screen (cached per section).
export const sectionTourSteps = async (ctx) => {
  const ck = `wz_tour_cache_${ctx.key}`;
  try { const c = JSON.parse(localStorage.getItem(ck) || "null"); if (c?.steps?.length) return c.steps; } catch { /* ignore */ }
  const r = await api.baraaTour(ctx.label, collectUi());
  const steps = [{ title: ctx.label.replace("لوحة التحكم - ", ""), text: r.intro || "هذا القسم من أقسام النظام." }, ...r.steps];
  if (r.steps.length) localStorage.setItem(ck, JSON.stringify({ steps }));
  return steps;
};
